<template>
    
    <span class="relative z-0 inline-flex shadow-sm rounded-md">
        <button v-for="(option, index) in options" :key="option.value"
            type="button" @click="onClick(option.value)" 
            class="relative inline-flex items-center px-4 py-2 border text-sm font-medium focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
            :class="[index === 0 ? 'rounded-l-md' : index === options.length - 1 ? 'rounded-r-md -ml-px' : '-ml-px', option.value === value ? 'border-blue-600 bg-blue-600 text-white' : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50']">
            {{ option.label }}
        </button>
    </span>

</template>
<script>
export default {
    props: ['options', 'value'],
    methods: {
        onClick(value) {
            this.$emit('click', value);
        }
    }
}
</script>